export default import.meta.env
